module.exports = __webpack_public_path__ + "static/img/guide_img_12.079c9b82.jpg";